import { useEffect, useState } from "react";
import { XIcon } from "@heroicons/react/outline";

const ArtistCreateModal = ({ isOpen, onClose, onSubmit, loading }) => {
  const [form, setForm] = useState({
    stage_name: "",
    real_name: "",
    profile_picture: null,
  });

  const [preview, setPreview] = useState(null);

  useEffect(() => {
    if (!isOpen) return;

    setPreview(null);
    setForm({
      stage_name: "",
      real_name: "",
      profile_picture: null,
    });
  }, [isOpen]);

  if (!isOpen) return null;

  const handleChange = (key, value) => {
    setForm((prev) => ({ ...prev, [key]: value }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];

    if (!file) return;

    setForm((prev) => ({ ...prev, profile_picture: file }));
    setPreview(URL.createObjectURL(file));
  };

  const removeImage = () => {
    setForm((prev) => ({ ...prev, profile_picture: null }));
    setPreview(null);
  };

  const handleSubmit = () => {
    onSubmit(form);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60">
      <div className="w-full max-w-2xl bg-slate-900 border border-white/10 rounded-xl shadow-xl">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-white/10">
          <h2 className="text-lg font-semibold text-white">Add Artist</h2>

          <button onClick={onClose} className="text-slate-400 hover:text-white">
            <XIcon className="w-5 h-5" />
          </button>
        </div>

        {/* Body */}
        <div className="px-6 py-5 space-y-6 max-h-[70vh] overflow-y-auto">
          {/* Profile Picture Upload */}
          <div>
            <label className="block text-sm text-slate-300 mb-2">
              Profile Picture
            </label>

            <div className="flex items-center gap-4">
              {preview && (
                <div className="relative">
                  <img
                    src={preview}
                    alt="preview"
                    className="w-20 h-20 object-cover rounded-full border border-white/10"
                  />
                  <button
                    onClick={removeImage}
                    className="absolute -top-2 -right-2 bg-black text-white rounded-full p-1 text-xs"
                  >
                    ✕
                  </button>
                </div>
              )}

              <input
                type="file"
                accept="image/*"
                onChange={handleImageChange}
                className="text-sm text-slate-300
                file:mr-4 file:py-2 file:px-4
                file:rounded-lg file:border-0
                file:text-sm file:font-medium
                file:bg-pink-600 file:text-white
                hover:file:bg-pink-700"
              />
            </div>
          </div>

          {/* Basic Info */}
          <div className="grid grid-cols-1 md:grid-cols-1 gap-4">
            <div>
              <label className="block text-sm text-slate-300 mb-1">
                Stage Name
              </label>
              <input
                type="text"
                value={form.stage_name}
                onChange={(e) => handleChange("stage_name", e.target.value)}
                className="w-full bg-[#131C31] border border-white/10 rounded-lg px-4 py-2.5 text-sm text-white focus:outline-none focus:ring-2 focus:ring-pink-500/40"
              />
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-1 gap-4">
            <div>
              <label className="block text-sm text-slate-300 mb-1">
                Real Name
              </label>
              <input
                type="text"
                value={form.real_name}
                onChange={(e) => handleChange("real_name", e.target.value)}
                className="w-full bg-[#131C31] border border-white/10 rounded-lg px-4 py-2.5 text-sm text-white focus:outline-none focus:ring-2 focus:ring-pink-500/40"
              />
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="flex justify-end gap-3 px-6 py-4 border-t border-white/10">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm rounded-lg text-slate-300 hover:bg-slate-800 transition"
          >
            Cancel
          </button>

          <button
            onClick={handleSubmit}
            disabled={loading}
            className={`px-4 py-2 text-sm rounded-lg text-white font-medium transition
              ${
                loading
                  ? "bg-pink-400 cursor-not-allowed"
                  : "bg-pink-600 hover:bg-pink-700"
              }
            `}
          >
            {loading ? "Saving..." : "Create Artist"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ArtistCreateModal;
